import React from 'react';
import Icon from 'components/AppIcon';

const ThemeToggle = ({ isDark, onToggle }) => (
  <button
    onClick={onToggle}
    aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    title={isDark ? 'Modo claro' : 'Modo oscuro'}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
      borderRadius: 'var(--radius-md)',
      border: '1.5px solid var(--color-border)',
      backgroundColor: 'var(--color-muted)',
      color: 'var(--color-muted-foreground)',
      cursor: 'pointer',
      transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = 'var(--color-card)';
      e.currentTarget.style.color = 'var(--color-primary)';
      e.currentTarget.style.borderColor = 'var(--color-primary)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = 'var(--color-muted)';
      e.currentTarget.style.color = 'var(--color-muted-foreground)';
      e.currentTarget.style.borderColor = 'var(--color-border)';
    }}
  >
    <Icon name={isDark ? 'Sun' : 'Moon'} size={17} color="currentColor" />
  </button>
);

export default ThemeToggle;
